export default {
  name: 'Rozszerzenie przesuwania',
  buttons: [
    {
      title: 'Przesuwanie'
    }
  ]
}